import React from "react";
import { Box, Heading, Hidden, Inline, Switch } from "@origin-digital/ods-core";
import { usePageTitleSection } from "./usePageTitleSection";

export const PageTitleSection = () => {
  const { isHomeUser, groupByProjectsSwitchProps } = usePageTitleSection();
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      gap={["small", "medium"]}
      data-id="pageTitleSection.root"
    >
      <Heading variant="h3">Projects</Heading>
      {/* Group projects switch */}
      {!isHomeUser && (
        <Switch
          id="group-by-projects"
          checked
          label={
            (
              <Inline>
                <Hidden below="sm">Group by projects</Hidden>
                <Hidden above="sm">Projects</Hidden>
              </Inline>
            ) as unknown as string
          }
          {...groupByProjectsSwitchProps}
        />
      )}
      {/* End Group projects */}
    </Box>
  );
};
